export const messages = {
    nb: {
        header: "",
        beskrivelse: "",
        TaC_T1: "Rapporter",
        TaC_T2: "Varsling",
        Tac_T3: "Dashbord",
    }
} 